var path = '/ssd/jenkins/workspace/Unmanaged/Release_arcade-ui/app/views/ui/rolodex-card.html';
var html = "<div class=\"rolodex-card\" ng-class=\"{active: $active}\" ng-transclude></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;